import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
// import React from 'react';
import Popover from '@material-ui/core/Popover';
import SlidingPane from 'react-sliding-pane';
import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { fade, lighten, makeStyles, useTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

import Tooltip from '@material-ui/core/Tooltip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Grid from "@material-ui/core/Grid";
import TextField from '@material-ui/core/TextField';
//import AccountCircle from '@material-ui/icons/AccountCircle';
import IconSearchRounded from '@material-ui/icons/SearchRounded';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
// import DatawarehouseDealerDetail from './DatawarehouseDealerDetail';
import { createLiteralTypeNode } from 'typescript';

const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5),
    },

}));


function TablePaginationActions(props: any) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = (event: any) => {
        onChangePage(event, 0);
    };

    const handleBackButtonClick = (event: any) => {
        onChangePage(event, page - 1);
    };

    const handleNextButtonClick = (event: any) => {
        onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = (event: any) => {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

//function descendingComparator(a, b, orderBy: any) {
function descendingComparator(a: any, b: any, orderBy: any) {
    //alert(a[orderBy]);
    //console.log("orderBy:" + orderBy);
    var x = a[orderBy];
    var y = b[orderBy];
    //console.log("orderBy: " + orderBy );

    if (orderBy.toLowerCase() == "dealername") {
        //console.log("123orderBy:" );
        x = x.toLowerCase();
        y = y.toLowerCase();
        //console.log("456orderBy:" );
        //console.log("123orderBy:" + orderBy + " : " + x );
    }
    if (a[orderBy] == null) {
        if (orderBy == 'dateLastUsed') {
            x = '01/01/2020';
        }
    }
    if (b[orderBy] == null) {
        if (orderBy == 'dateLastUsed') {
            y = '01/01/2020';
        }
    }

    // if (b[orderBy] < a[orderBy]) {
    //     return -1;
    // }
    // if (b[orderBy] > a[orderBy]) {
    //     return 1;
    // }
    if (y < x) {
        return -1;
    }
    if (y > x) {
        return 1;
    }
    return 0;
}



function getComparator(order: any, orderBy: any) {
    return order === 'desc'
        ? (a: any, b: any) => descendingComparator(a, b, orderBy)
        : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

function stableSort(array: any, comparator: any) {


    const stabilizedThis = array
        .map((el: any, index: any) => [el, index]);
    stabilizedThis.sort((a: any, b: any) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el: any) => el[0]);
}

const headCells = [
    { id: 'TrackDate', numeric: false, disablePadding: false, label: 'TrackDate' },
    { id: 'ActiveUser', numeric: true, disablePadding: false, label: 'ActiveUser' },
    // { id: 'dmsDealerId', numeric: true, disablePadding: false, label: 'DmsDealerId' },
    // { id: 'dealerName', numeric: false, disablePadding: false, label: 'Name' },
    // { id: 'address', numeric: false, disablePadding: false, label: 'Address' },
    // { id: 'city', numeric: false, disablePadding: false, label: 'City' },
    // { id: 'stateOrProvince', numeric: false, disablePadding: false, label: 'State' },
    // { id: 'zipPostal', numeric: false, disablePadding: false, label: 'Zip' },
    // { id: 'dmsName', numeric: false, disablePadding: false, label: 'Type' },
    // { id: 'phone', numeric: false, disablePadding: false, label: 'Phone' },
    // { id: 'email', numeric: false, disablePadding: false, label: 'Email' },

];

function EnhancedTableHead(props: any) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = (property: any) => (event: any) => {
        onRequestSort(event, property);
    };


    return (
        <TableHead>
            <TableRow>
                {/* <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
          />
        </TableCell> */}
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    title: {
        flex: '1 1 100%',
    },
}));

const EnhancedTableToolbar = (props: any) => {
    const classes = useToolbarStyles();
    const { numSelected } = props;

    return (
        <div></div>
        // <Toolbar
        //   className={clsx(classes.root, {
        //     [classes.highlight]: numSelected > 0,
        //   })}
        // >
        //   {numSelected > 0 ? (
        //     <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
        //       {numSelected} selected
        //     </Typography>
        //   ) : (
        //     <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
        //       Nutrition
        //     </Typography>
        //   )}

        //   {numSelected > 0 ? (
        //     <Tooltip title="Delete">
        //       <IconButton aria-label="delete">
        //         {/* <DeleteIcon /> */}
        //       </IconButton>
        //     </Tooltip>
        //   ) : (
        //     <Tooltip title="Filter list">
        //       <IconButton aria-label="filter list">
        //         {/* <FilterListIcon /> */}
        //       </IconButton>
        //     </Tooltip>
        //   )}
        // </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        fontSize: "Large"
    },

    typography: {
        padding: theme.spacing(2),
    },

    inActiveDealer: {
        color: "red",
        textDecoration: 'line-through'

    },
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: "white",
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        color: "white",
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        fontWeight: "bolder",
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            }
        },
    },
}));

const TargetMatrics = (props: any) => {
    // alert('EnhancedTable');

    // export default function EnhancedTable(props) {
    //const { dealerId } = props.id;
    //  console.error("eeeeeee");
    //  console.error(props);
    //  alert(props.id);
    //  console.error(ppppppp);
    const [queryType, SetQueryType] = React.useState('0') as any;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('');
    const [selected, setSelected] = React.useState([]);
    const [dense, setDense] = React.useState(true);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(20);
    const [data, SetData] = useState([]);
    const [dataDetail, SetDataDetail] = useState([]);
    const [searchdata, SetSearchdata] = useState('');
    const [loading, setLoading] = useState('Please wait.. gathering data');
    const [isPaneOpen, SetIsPaneOpen] = React.useState(false);
    const [childMessages, SetChildMessages] = useState([] as any);
    const [matricDetailTag, SetMatricDetailTag] = React.useState('asc');


    // const [dealerName, SetDealerName] = useState([]);
    // const [editDealerID, SetEditDealerID] = useState(0);
    // const [currentLocationRow, SetCurrentLocationRow] = useState([]);

    const handleCloseAdmin = () => {
        setAnchorEl(null);
    };

    function GetMatricsDetails(id: number, tag: string, eTarget: any, jsonObj: string) {
        SetDataDetail([]);
        //let url = 'http://localhost:7071/api/GetTargetMatricDetail/' + id + '/' + tag + '/' + queryType  + '/' + jsonObj ;
        //let url = window.DataService.url + 'api/GetTargetMatricDetail/' + id + '/' + tag + '?code=9e7e0AOUnSE/s1UxPxyOCZHN0nrOh81eZAOdvEBvsCf9bj1efIldMQ==';
        let url = 'https://azurefunctionkg.azurewebsites.net/api/GetTargetMatricDetail/' + id + '/' + tag + '/' + queryType + '/' + jsonObj + '?code=9e7e0AOUnSE/s1UxPxyOCZHN0nrOh81eZAOdvEBvsCf9bj1efIldMQ==';
        //alert(url);
        fetch(url)
            .then(response => response.json())
            .then(data =>
            (
                // alert('test1'),
                SetDataDetail(data.TargetMatricDetail),
                // alert('test2'),
                setAnchorEl(eTarget)
                // alert('test3')
            )

            ).catch((error) => {
                // Only network error comes here
                //alert(error);
                setAnchorEl(null);
            });

    }

    function ShopPopover(e: any, currentRow: any, tag: any) {

        //  if(queryType==0){
        SetMatricDetailTag(tag);
        GetMatricsDetails(currentRow.UsageMatricId, tag, e.currentTarget, JSON.stringify(currentRow));
        //  }


        //          alert(currentRow.TrackDate);

        //         var index = GetData().findIndex(function(item:any, i){
        //             return item.UsageMatricId<currentRow.UsageMatricId
        //           });
        // alert(GetData()[index].TrackDate);

    }


    let rowEventHandled = 0;

    function GetData(): any {
        return data.filter(filterRow);
    }
    function filterRow(element: any, index: any, array: any) {
        if (data.length > 0) {
            var obj1 = data[0];
            var keys = Object.keys(obj1);
            let i = 0;
            for (i = 0; i < keys.length; i++) {
                let cellValue = String(element[keys[i]]);
                if (cellValue.toLowerCase().includes(searchdata.toLowerCase())) { return true; }
            }
        }
        return false;

        // if (myName === '') { return true };
        // let name: string = element['name'];
        // let address: string = element['address'];
        // if (name.toLowerCase().includes(myName.toLowerCase())) { return true; }
        // if (address.toLowerCase().includes(myName.toLowerCase())) { return true; }
        // return false;
    }

    function closeModal() {
        SetIsPaneOpen(false);
    }


    useEffect(() => {
        //alert('TargetMatrics');
        //alert(props.dealer);

        //let url = 'http://localhost:7071/api/GetTargetMatrics/' + queryType;
        ////https://azurefunctionkg.azurewebsites.net/api/GetTargetMatrics?code=7E6hXRR/1vEa7gu0tXxtlGZMwSRkRGN7vkeMRKwE2l8rC2FblnJZuw==
        let url = 'https://azurefunctionkg.azurewebsites.net/api/GetTargetMatrics/' + queryType + '?code=7E6hXRR/1vEa7gu0tXxtlGZMwSRkRGN7vkeMRKwE2l8rC2FblnJZuw==';
        fetch(url)
            .then(response => response.json())
            .then(data =>
            (
                // alert(data),
                // alert(data.TargetMatrics),
                // alert(data.TargetMatrics.length),
                // console.log('data[0]'),
                // console.log(data[0]),
                // SetData(data),
                SetData(data.TargetMatrics),
                setLoading(''),
                SetIsPaneOpen(true)

            )

            ).catch(error => alert('Error: ' + error));

    }, [queryType]);


    const handleRequestSort = (event: any, property: any) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event: any) => {
        // if (event.target.checked) {
        //     alert('handleSelectAllClick');
        //     const newSelecteds = data.map((n) => n.name);
        //     setSelected(newSelecteds);
        //     return;
        // }
        // setSelected([]);
    };

    //const handleRowClick = (event, name) => {
    // const selectedIndex = selected.indexOf(name);
    // let newSelected = [];

    // if (selectedIndex === -1) {
    //     newSelected = newSelected.concat(selected, name);
    // } else if (selectedIndex === 0) {
    //     newSelected = newSelected.concat(selected.slice(1));
    // } else if (selectedIndex === selected.length - 1) {
    //     newSelected = newSelected.concat(selected.slice(0, -1));
    // } else if (selectedIndex > 0) {
    //     newSelected = newSelected.concat(
    //         selected.slice(0, selectedIndex),
    //         selected.slice(selectedIndex + 1),
    //     );
    // }

    // setSelected(newSelected);
    //};

    const handleChangePage = (event: any, newPage: any) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeDense = (event: any) => {
        setDense(event.target.checked);
    };


    const handleRowClick = (currentRow: any) => {
        alert(currentRow.UsageMatricId);
        // //alert('handleDealerRowClick');
        // // alert(currentRow.aspenLocationId);
        // // const _setChildDealerSurvey = <DealerSurveys key={new Date().getTime()} id={id} dealer={FindDealerName(id)} />;
        // let _datawarehouseDealerDetail = <DatawarehouseDealerDetail  key={new Date().getTime()} dmsDealerId={currentRow.dmsDealerId} currentRow={currentRow} />;
        // SetChildMessages(_datawarehouseDealerDetail)



    };


    // const isSelected = (name :any) => selected.indexOf(name) !== -1;

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    return (

        <div style={{ position: "relative", border: "0px solid red" }} className={classes.root}>
            {/* <SlidingPane
                className='some-custom-class'
                overlayClassName='some-custom-overlay-class'
                isOpen={isPaneOpen}
                title={props.dealer}
                subtitle="Survey's In last 30 days"
                onRequestClose={closeModal}> */}



            <div style={loading == '' ? { display: "none" } : {}}><h1>{loading}</h1></div>
            {/* {searchdata} */}
            {/* <Paper xclassName={classes.paper} xstyle={{ width:1175, marginTop:10  }}></Paper> */}
            <FormControl className={classes.formControl}>
                {/* <InputLabel id="demo-simple-select-label">Period</InputLabel> */}
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={queryType}
                    onChange={(e) => { SetQueryType(e.target.value); }}
                >
                    <MenuItem value={0}>Hourly</MenuItem>
                    <MenuItem value={1}>Daily</MenuItem>
                    <MenuItem value={2}>Weekly</MenuItem>
                    <MenuItem value={3}>Monthly</MenuItem>
                </Select>
            </FormControl>
            <Paper style={{ display: "table" }}>
                <div style={{ position: "fixed", top: "8px", right: "10px" }}>
                    <table>
                        <tr>
                            <td>
                                {/* <div style={{ position: "fixed", right: "15px", top: "15px" }} className={classes.search}>
                                    <div className={classes.searchIcon}>
                                        <SearchIcon />
                                    </div>
                                    <InputBase
                                        placeholder="Search…"
                                        classes={{
                                            root: classes.inputRoot,
                                            input: classes.inputInput,
                                        }}
                                        inputProps={{ 'aria-label': 'search' }}
                                        onChange={(e) => SetSearchdata(e.target.value)}
                                    />
                                </div> */}

                            </td>
                            <td>


                            </td>
                        </tr>
                    </table>


                </div>




                <EnhancedTableToolbar numSelected={selected.length} />
                <TableContainer>
                    <Table
                        className={'myTable2 ' + classes.table}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                        aria-label="enhanced table"
                    >
                        {/* <EnhancedTableHead
                            classes={classes}
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={GetData().length}
                        /> */}
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ display: queryType == 0 ? '' : 'none' }} >Track Time (UTC)</TableCell>
                                <TableCell style={{ display: queryType == 1 ? '' : 'none' }} >Date (UTC)</TableCell>
                                <TableCell style={{ display: queryType == 2 ? '' : 'none' }} >Week (UTC)</TableCell>
                                <TableCell style={{ display: queryType == 3 ? '' : 'none' }} >Monthly (UTC)</TableCell>
                                <TableCell>Dealers</TableCell>
                                <TableCell>Users</TableCell>
                                <TableCell>Messages</TableCell>
                                <TableCell>Outbound</TableCell>
                                <TableCell>Inbound</TableCell>
                                <TableCell>Broadcast</TableCell>
                                <TableCell>Survey</TableCell>
                                <TableCell>Text</TableCell>
                                <TableCell>SMS</TableCell>
                                <TableCell>MMS</TableCell>
                                <TableCell>Feedbacks</TableCell>
                                <TableCell>Errors</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                //    stableSort(rows, getComparator(order, orderBy))
                                stableSort(GetData(), getComparator(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    //data
                                    .map((row: any, index: any) => {
                                        // console.warn('ktest');
                                        // // const isItemSelected = isSelected(row.dealerId);
                                        // const labelId = `enhanced-table-checkbox-${index}`;
                                        // let name=row.dealerName;
                                        // let inactive=0;
                                        // if(row.isActive=="False") {name=name+ " [INACTIVE] ";inactive=1};
                                        // if(row.isDealerLocation=="False") {name=name+ " [ISDEALERLOCATION=0]";inactive=1};
                                        // let xclass="";
                                        // if(inactive==1)xclass=classes.inActiveDealer

                                        let utcDate = new Date(row.TrackDate);

                                        const myLocalDate = new Date(Date.UTC(
                                            utcDate.getFullYear(),
                                            utcDate.getMonth(),
                                            utcDate.getDate(),
                                            utcDate.getHours(),
                                            utcDate.getMinutes()
                                        ));
                                        // let surveyDate = new Date(myLocalDate).toLocaleDateString();
                                        // let surveyTime = new Date(myLocalDate).toLocaleTimeString();
                                        // let surveyDate = new Date(myLocalDate).toString()
                                        // let surveyTime = new Date(myLocalDate).toTimeString();

                                        // xclass="";

                                        return (
                                            <TableRow
                                            // hover
                                            // role="checkbox"

                                            // tabIndex={-1}
                                            // key={row.name}
                                            >
                                                {/* <TableCell align="center" style={{display:queryType==0?'':'none'}} >{surveyDate} {surveyTime}</TableCell> */}
                                                {/* <TableCell align="center" style={{display:queryType==0?'':'none'}} >{surveyDate} </TableCell> */}
                                                <TableCell align="center" style={{ display: queryType == 0 ? '' : 'none' }} >{row.TrackDate}</TableCell>
                                                <TableCell align="center" style={{ display: queryType == 0 ? 'none' : '' }} >{row.Desc}</TableCell>
                                                {/* <TableCell align="center" style={{display:queryType==2?'':'none'}} >{row.Week}</TableCell> */}
                                                <TableCell align="center" >{row.ActiveDealers}</TableCell>
                                                <TableCell align="center" >{row.ActiveUsers}</TableCell>
                                                {/* <TableCell align="center" onClick={(event) => handleRowClick(row)} >{row.MessageCount}</TableCell> */}
                                                <TableCell align="center" onClick={e => ShopPopover(e, row, 'MessageCount')} >{row.MessageCount}</TableCell>

                                                <TableCell align="center" >{row.MessageOutbound}</TableCell>
                                                <TableCell align="center" >{row.MessageInbound}</TableCell>
                                                <TableCell align="center" >{row.MessageBroadcast}</TableCell>
                                                <TableCell align="center" >{row.MessageSurvey}</TableCell>
                                                <TableCell align="center" >{row.MessageText}</TableCell>
                                                <TableCell align="center" >{row.MessageSMS}</TableCell>
                                                <TableCell align="center" >{row.MessageMMS}</TableCell>
                                                <TableCell align="center" >{row.Feedbacks}</TableCell>
                                                {/* <TableCell align="center" >{row.MessageErrors}</TableCell> */}
                                                <TableCell align="center" onClick={e => ShopPopover(e, row, 'MessageErrors')} >{row.MessageErrors}</TableCell>

                                                {/* <TableCell align="center">{row.dmsDealerId}</TableCell>
                                                <TableCell  className={xclass}>{name}</TableCell>
                                                
                                                <TableCell>{row.address}</TableCell>
                                                <TableCell>{row.city}</TableCell>
                                                <TableCell>{row.stateOrProvince}</TableCell>
                                                <TableCell>{row.zipPostal}</TableCell>
                                                <TableCell>{row.dmsName}</TableCell>
                                                <TableCell>{row.phone}</TableCell>
                                                <TableCell>{row.email}</TableCell> */}

                                            </TableRow>
                                        );
                                    })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                {/* <TablePagination
                    rowsPerPageOptions={[10, 15, 20, 25, 30]}
                    component="div"
                    count={GetData().length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}

                /> */}
                <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 20, 25]}
                    component="div"
                    count={GetData().length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                />
            </Paper>
            <div>{childMessages}</div>
            {/* </SlidingPane> */}

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleCloseAdmin}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <Typography className={classes.typography}>
                    {matricDetailTag == 'MessageCount' && (
                        <TableContainer>
                            <Table
                                className={'myTable2 ' + classes.table}
                                aria-labelledby="tableTitle"
                                size={dense ? 'small' : 'medium'}
                                aria-label="enhanced table"
                            >

                                <TableHead>
                                    <TableRow>
                                        <TableCell>DealerId</TableCell>
                                        <TableCell>Dealer</TableCell>
                                        <TableCell align="center" >Count (Appx**)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {dataDetail.map((row: any) => {
                                        return (
                                            <TableRow>
                                                <TableCell > {row.DmsDealerIdCrm}</TableCell>
                                                <TableCell > {row.name}</TableCell>
                                                <TableCell align="center" > {row.Messages}</TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                    {matricDetailTag == 'MessageErrors' && dataDetail.length > 0 && (
                        <TableContainer>
                            <Table
                                className={'myTable2 ' + classes.table}
                                aria-labelledby="tableTitle"
                                size={dense ? 'small' : 'medium'}
                                aria-label="enhanced table"
                            >

                                <TableHead>
                                    <TableRow>
                                        <TableCell>DealerId</TableCell>
                                        <TableCell>Dealer</TableCell>
                                        <TableCell>Customer</TableCell>
                                        <TableCell>Error</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {dataDetail.map((row: any) => {
                                        return (
                                            <TableRow>
                                                <TableCell > {row.DmsDealerIdCrm}</TableCell>
                                                <TableCell > {row.Dealer}</TableCell>
                                                <TableCell > {row.Customer}</TableCell>
                                                <TableCell style={{}} > {row.ErrorMessage}</TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </Typography>
            </Popover>
        </div>
    );
}
export default TargetMatrics